// On page load, handle input char count
document.addEventListener('DOMContentLoaded', function () {
  const customizationContainer = document.querySelector('.customization-container');
  if (!customizationContainer) return;

  const textField = customizationContainer.querySelector('#customization-text-field');
  const charNumber = customizationContainer.querySelector('.char-number');
  const errorMessage = customizationContainer.querySelector('.error');

  if (textField && charNumber && errorMessage) {
    const maxChar = window.customizationSettings?.max_char || 25;

    const updateCharCount = () => {
      const currentLength = textField.value.length;
      charNumber.textContent = `${currentLength}/${maxChar}`;

      if (currentLength > maxChar) {
        errorMessage.removeAttribute('hidden');
      } else {
        errorMessage.setAttribute('hidden', true);
      }
    };

    textField.addEventListener('input', updateCharCount);
    updateCharCount();
  }
});

// CART VALIDATION
document.addEventListener('DOMContentLoaded', () => {
  const cartValidationModule = createCartValidationModule();
  cartValidationModule.observeForCheckoutButtonCreation();
});

function createCartValidationModule() {
  async function observeForCheckoutButtonCreation() {
    const observer = new MutationObserver(mutationsList => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const elements = document.querySelectorAll(
            'form.cart-drawer__footer button[name="checkout"]'
          );
          elements.forEach(element => {
            if (!element.hasAttribute('data-bound')) {
              element.setAttribute('data-bound', 'true');
              bindGoToCheckout(element);
            }
          });
        }
      }
    });

    const targetNode = document.querySelector('cart-drawer');
    if (targetNode) {
      observer.observe(targetNode, { childList: true, subtree: true });
    }
    const cartPage = document.querySelector('.cart-page');
    const submitButton = cartPage?.querySelector('button[name="checkout"]');
    submitButton?.setAttribute('data-bound', 'true');
    if (cartPage && submitButton) bindGoToCheckout(submitButton);

    const cartDrawer = document.querySelector('.cart-drawer');
    const checkoutButton = cartDrawer?.querySelector('button[name="checkout"]');
    checkoutButton?.setAttribute('data-bound', 'true');
    if (cartDrawer && checkoutButton) bindGoToCheckout(checkoutButton);
  }

  function bindGoToCheckout(element) {
    if (!element) return;
    const form = element.closest('form')
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const checkbox = element.closest('form').querySelector('input.term-and-conditions__checkbox[type="checkbox"]');
      if (checkbox && !checkbox.checked) {
        const errorMessage = form.querySelector('.form-error-message');
        if (errorMessage) {
          errorMessage.removeAttribute('hidden');
        }
        return;
      }

      const cartPage = document.querySelector('.cart-page');
      if (cartPage) {
        if (!window.sintraElectronicInvoice().validate()) {
          return;
        }
      }
      await verifyCartContent();
      await checkoutValidation(e, cartPage);
    });
  }

  async function checkoutValidation(event, isCartPage) {
    const button = event.target;
    button.disabled = true;

    try {
      await validateCart();
      isCartPage = document.querySelector('.cart-page');
      if (isCartPage) {
        event.target.submit();
      } else {
        window.location.href = `${Shopify.routes.root}checkout`;
      }
    } catch (error) {
      console.error('Cart validation failed:', error);
    } finally {
      button.disabled = false;
    }
  }

  async function validateCart() {
    const cart = await fetchCart();
    await initCartValidation(cart);
  }

  async function fetchCart() {
    const response = await fetch(`${Shopify.routes.root}cart.js`, {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch cart data');
    }

    return response.json();
  }
  async function initCartValidation(cart) {
    try {
      const itemsToRemove = [];
      let forbiddenIds = window.customizationSettings.forbidden_products.toString();

      if (forbiddenIds.includes(',')) {
        forbiddenIds = forbiddenIds.split(',');
        forbiddenIds = forbiddenIds.map(id => id.toString());
      }
      const bundles = generateBundles(cart.items);

      Object.entries(bundles).forEach(([key, bundle]) => {
        if (key === 'no_bundle') {
          return;
        }
        const bundleValidation = isBundleValid(bundle);

        if (!bundleValidation.valid) {
          itemsToRemove.push(...bundle);
        }
      });
      if (bundles?.no_bundle) {
        bundles.no_bundle.forEach(item => {
          if (forbiddenIds.includes(item.properties._id) || forbiddenIds.includes(item.id.toString())) {
            itemsToRemove.push(item);
          }
        });
      }
      if (itemsToRemove.length != 0) {
        await removeCartItems(itemsToRemove);
      }
    } catch (error) {
      throw new Error('Cart validation failed', error);
    }
  }

  const generateBundles = items => {
    return items.reduce((bundles, item) => {
      if (item.properties && item.properties._isGiftbox) {
        return bundles;
      }
      const bundleId = item.properties && item.properties._id ? item.properties._id : 'no_bundle';
      if (!bundles[bundleId]) {
        bundles[bundleId] = [];
      }
      bundles[bundleId].push(item);
      return bundles;
    }, {});
  };

  function isBundleValid(bundle) {
    const mainProduct = getMainProduct(bundle);
    if (mainProduct) {
      const isQuantityValid = checkQuantity(bundle, mainProduct);
      const isBundleCompositionCorrect = checkBundleComposition(bundle, mainProduct);
      if (!isQuantityValid || !isBundleCompositionCorrect) {
        return {
          valid: false,
          error: 'invalid_bundle'
        };
      } else {
        return {
          valid: true
        };
      }
    } else {
      return {
        valid: false,
        error: 'no_main_product'
      };
    }
  }

  function getMainProduct(bundle) {
    let mainItem = [];
    bundle.forEach(item => {
      if (item.id.toString() == item.properties._id.split(':')[0].toString()) {
        mainItem.push(item);
      }
    });

    if (mainItem.length > 1) {
      return null;
    }
    return mainItem[0];
  }

  function checkQuantity(bundle) {
    const firstItemQuantity = bundle[0].quantity;
    return bundle.every(item => item.quantity === firstItemQuantity);
  }

  function checkBundleComposition(bundle, mainProduct) {
    const bundlesIds = bundle.map(item => item.id.toString());
    const customizationId = mainProduct.properties?._customizationProductId;

    if (customizationId) {
      return isCustomizationPresent(bundlesIds, customizationId);
    }

    return false;
  }

  function isCustomizationPresent(bundlesIds, customizationId) {
    return customizationId && bundlesIds.includes(customizationId.toString());
  }

  async function removeCartItems(itemsToRemove) {
    const itemKeys = itemsToRemove.map(item => item.key);

    const updates = itemKeys.reduce((acc, key) => {
      acc[key] = 0;
      return acc;
    }, {});

    const products_titles = getProductsName(itemsToRemove);
    const error_message = window.themeVariables.strings.productFormForbiddenProductsRemoved + ' ' + products_titles;

    return new Promise(async resolve => {
      fetch(`${Shopify.routes.root}cart` + '/update.js', {
        body: JSON.stringify({ updates }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => {
          response.json().then(function (content) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            document.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: null,
                  quantity: 0,
                  errorMessage: error_message
                }
              })
            );
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            resolve(true);
          });
        })
        .catch(error => {
          throw new Error('Failed to remove cart items', error);
        });
    });
  }

  function getProductsName(itemsToRemove) {
    let products_titles = [];
    itemsToRemove.forEach(item => {
      products_titles.push(item.title);
    });

    return products_titles.toString();
  }

  return {
    observeForCheckoutButtonCreation,
    bindGoToCheckout,
    checkoutValidation,
    validateCart,
    fetchCart,
    initCartValidation,
    generateBundles,
    isBundleValid,
    getMainProduct,
    checkQuantity,
    checkBundleComposition,
    isCustomizationPresent,
    removeCartItems,
    getProductsName
  };
}

// GIFTBOX LOGIC

document.addEventListener('DOMContentLoaded', async () => {
  document.querySelectorAll('input[name="giftbox-checkbox-option"]').forEach(checkbox => {
    checkbox.addEventListener('change', updateSubmitState);
  });
  // Elements
  const selectorContainer = document.querySelector('.product-selector-container');
  const selectedContainer = document.querySelector('.selected-products-container');
  const submitButton = document.querySelector('.giftbox-submit-button');
  const giftboxProductsVariantIds = Array.from(document.querySelectorAll('.giftbox-product-container')).map(
    product => product.dataset.variantId
  );

  if (!selectorContainer || !selectedContainer || !submitButton) return;

  let availableProductsList = {};
  let selectedItem = {};

  // Fetch cart and initialize
  const cart = await fetchCart();
  const cartItems = cart.items;
  updateAvailableProductList();

  const select = document.createElement('select');
  select.classList.add('select');
  select.setAttribute('name', 'gift-product-selector');
  selectorContainer.appendChild(select);
  updateSelectOptions();

  select.addEventListener('change', () => {
    const variantId = select.value;

    if (!availableProductsList[variantId]) return;
    selectedItem = {};
    selectedItem[variantId] = 1;

    updateSelectOptions();
    updateSelectedItemUI();
    updateSubmitState();
  });

  submitButton.addEventListener('click', async () => {
    if (Object.keys(selectedItem).length === 0) return;

    addGiftboxToCart(selectedItem);
    updateAvailableProductList();
    resetUI();
  });

  function updateSelectOptions() {
    select.innerHTML = `<option disabled>${window.giftboxTexts.selectProduct}</option>`;

    Object.entries(availableProductsList).forEach(([id, { name, quantity, properties, key }]) => {
      const selectedQty = selectedItem[id] || 0;
      let optionName;
      if (properties._customizationText) {
        optionName = `${name} - ${properties._customizationText}`;
      } else {
        optionName = name;
      }
      const remaining = quantity - selectedQty;
      for (let i = 0; i < remaining; i++) {
        const option = document.createElement('option');
        option.value = key;
        option.textContent = optionName;
        select.appendChild(option);
      }
    });

    // set the value to show the selected option
    setTimeout(() => {
      select.value = window.giftboxTexts.selectProduct;
    }, 500);
  }

  function updateSelectedItemUI() {
    selectedContainer.innerHTML = '';

    Object.entries(selectedItem).forEach(([variantId, quantity]) => {
      const item = availableProductsList[variantId];

      const li = document.createElement('li');
      li.textContent = `${item.name} × ${quantity}`;

      const removeBtn = document.createElement('button');
      removeBtn.textContent = window.giftboxTexts.removeProduct;
      removeBtn.type = 'button';

      removeBtn.addEventListener('click', () => {
        selectedItem[variantId] -= 1;
        if (selectedItem[variantId] <= 0) {
          delete selectedItem[variantId];
        }

        updateSelectOptions();
        updateSelectedItemUI();
        updateSubmitState();
      });

      li.appendChild(removeBtn);
      selectedContainer.appendChild(li);
    });
  }

  function updateSubmitState() {
    const selectedGiftbox = document.querySelector('input[name="giftbox-checkbox-option"]:checked');
    const hasItems = Object.values(selectedItem).some(qty => qty > 0);
    if (!selectedGiftbox || !hasItems) {
      submitButton.disabled = true;
      submitButton.classList.add('disabled');
    } else {
      submitButton.disabled = false;
      submitButton.classList.remove('disabled');
    }
  }
  function updateAvailableProductList() {
    const boxes = cartItems.filter(item => item.properties && item.properties._isGiftbox);

    const itemsInBoxes = boxes.map(box => box.properties._selectedItem).filter(Boolean);

    const itemsInBoxesMap = itemsInBoxes.reduce((acc, id) => {
      const normalizedId = id.split(':')[0];
      if (!acc[normalizedId]) {
        acc[normalizedId] = 1;
      } else {
        acc[normalizedId] += 1;
      }
      return acc;
    }, {});

    cartItems.forEach(item => {
      if (item.discounted_price == 0) return;

      if (giftboxProductsVariantIds.includes(item.id.toString())) {
        return;
      }

      const customizationIds = window.customizationSettings?.forbidden_products;
      if (customizationIds && customizationIds.includes(item.id.toString())) {
        return;
      }

      const normalizedKey = item.key.split(':')[0];
      const boxQuantity = itemsInBoxesMap[normalizedKey] || 0;

      if (item.quantity > boxQuantity) {
        availableProductsList[item.key] = {
          key: item.key,
          name: item.product_title,
          quantity: item.quantity - boxQuantity,
          properties: item.properties || {}
        };
      }
    });
  }

  function resetUI() {
    availableProductsList = {};
    const checkboxes = document.querySelectorAll('input[name="giftbox-checkbox-option"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
    updateSelectOptions();
    selectedContainer.innerHTML = '';
    updateSubmitState();
  }

  async function addToCart(item) {
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item)
    });
    if (!response.ok) {
      throw new Error('Failed to add giftbox to cart');
    }
    const responseJson = await response.json();
    return responseJson;
  }

  async function addGiftboxToCart(selectedItem) {
    const selectedGiftbox = document.querySelector('input[name="giftbox-checkbox-option"]:checked');
    if (!selectedGiftbox) {
      alert('Please select a giftbox option.');
      return;
    }
    const submitButtons = Array.from(document.querySelectorAll('button[type=submit]'));
    initializeAddingToCartEvents(submitButtons);

    let responseJson = null;
    try {
      const selectedItemId = Object.keys(selectedItem)[0];
      const item = availableProductsList[selectedItemId];
      let mappedItemName;
      if (item.properties?._customizationText) {
        mappedItemName = `${item.name} - ${item.properties._customizationText}`;
      } else {
        mappedItemName = `${item.name}`;
      }

      const giftbox = {
        id: selectedGiftbox.value,
        quantity: 1,
        properties: {
          _isGiftbox: 'true',
          _id: `${selectedGiftbox.value}:${Date.now()}`,
          _selectedItem: selectedItemId,
          _selectedItemName: mappedItemName
        }
      };

      responseJson = await addToCart(giftbox);

      if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent['sections'] = responseJson['sections'];
  
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            onSuccessDo: formData?.get('on_success'),
            cart: cartContent
          }
        })
      );
    } catch (error) {
      console.error('Error adding giftbox to cart:', error);
      document.dispatchEvent(
        new CustomEvent('cart:error', {
          bubbles: true,
          detail: {
            error: responseJson?.description || error.message
          }
        })
      );
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      throw error;
    } finally {
      submitButtons.forEach(submitButton => {
        submitButton.removeAttribute('aria-busy');
      });
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }

  function initializeAddingToCartEvents(submitButtons) {
    let sectionsToBundle = [];
    submitButtons.forEach(submitButton => submitButton.setAttribute('aria-busy', 'true'));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );
  }
});
document.addEventListener('cart-drawer:refreshed', async e => {
  try {
    await verifyCartContent();
  } catch (error) {
    console.error('Error verifying cart content:', error);
  }
});

document.addEventListener('DOMContentLoaded', async e => {
  if (document.querySelector('.shopify-section--main-cart')) {
    try {
      await verifyCartContent();
    } catch (error) {
      console.error('Error verifying cart content:', error);
    }
  }
});

async function verifyCartContent() {
  const cart = await fetchCart();
  const cartContent = cart.items;

  const giftboxes = cartContent.filter(item => item.properties && item.properties._isGiftbox);

  const itemsInBoxes = giftboxes
    .map(giftbox => {
      const selectedItem = giftbox.properties._selectedItem;
      if (selectedItem) {
        return {
          id: selectedItem,
          quantity: 1,
          giftboxKey: giftbox.key
        };
      }
      return null;
    })
    .filter(Boolean);

  const reducedItems = itemsInBoxes.reduce((acc, item) => {
    const normalizedId = item.id.split(':')[0];
    let existingItem = acc.find(i => i.id === normalizedId);
    if (existingItem) {
      existingItem.quantity += item.quantity;
      existingItem.giftboxKeys.push(item.giftboxKey);
    } else {
      acc.push({ id: normalizedId, quantity: item.quantity, giftboxKeys: [item.giftboxKey] });
    }
    return acc;
  }, []);

  if (giftboxes.length === 0) {
    return;
  }

  if (giftboxes.length > 0 && itemsInBoxes.length > 0) {
    let boxesToRemove = [];
    for (const reducedBoxItem of reducedItems) {
      const cartItems = cartContent.filter(cartItem => {
        return cartItem.id.toString().split(':')[0] === reducedBoxItem.id;
      });

      const totalCartQuantity = cartItems.reduce((sum, cartItem) => sum + cartItem.quantity, 0);

      if (totalCartQuantity < reducedBoxItem.quantity) {
        console.warn(
          `Item with key ${reducedBoxItem.id} has incorrect quantity in cart: expected ${reducedBoxItem.quantity}, found ${totalCartQuantity}`
        );

        const exceedingCount = reducedBoxItem.quantity - totalCartQuantity;
        const exceedingGiftboxes = reducedBoxItem.giftboxKeys.slice(-exceedingCount);
        exceedingGiftboxes.forEach(boxKey => {
          boxesToRemove.push(boxKey);
        });
      }
    }
    if (boxesToRemove.length > 0) {
      const updates = {};
      boxesToRemove = [...new Set(boxesToRemove)];
      boxesToRemove.forEach(boxKey => {
        updates[boxKey] = 0;
      });
      try {
        await updateCart(updates);
        if (document.querySelector('.shopify-section--main-cart')) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } catch (error) {
        console.error('Error removing giftboxes from cart:', error);
      }
    }
  }
}

async function fetchCart() {
  const response = await fetch(`${Shopify.routes.root}cart.js`, {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch cart data');
  }

  return response.json();
}

async function changeCart(updates) {
  const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updates),
    keepalive: true
  });
  if (!response.ok) {
    throw new Error('Failed to change cart');
  }

  return response.json();
}

async function updateCart(updates) {
  const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates }),
    keepalive: true
  });
  if (!response.ok) {
    throw new Error('Failed to update cart');
  }

  return response.json();
}
// Cart Watcher
const inputListener = ({ target }) => {
  const inputName = target.getAttribute('name');
  const inputType = target.getAttribute('type');

  switch (inputType) {
    case 'checkbox':
      localStorage.setItem(
        inputName,
        JSON.stringify({
          value: target.value,
          checked: target.checked
        })
      );
      break;
    case 'radio':
    default:
      localStorage.setItem(
        inputName,
        JSON.stringify(target.value)
      );
  }

  if(target.value === '') {
    localStorage.removeItem(inputName);
  }
}

const inputWatcher = (input) => {
  const inputName = input.getAttribute('name');
  const inputValue = JSON.parse(localStorage.getItem(inputName));
  const inputType = input.getAttribute('type');

  switch (inputType) {
    case 'checkbox':
      !!inputValue &&
        inputValue.value === input.value &&
        inputValue.checked &&
        input.click();
      input.addEventListener('change', inputListener);
      break;
    case 'radio':
      !!inputValue &&
        input.value === inputValue &&
        input.click();
      input.addEventListener('change', inputListener);
      break;
    default:
      input.value = inputValue;
      input.addEventListener('input', inputListener);
  }

  if (
    (inputName === 'giftbox-checkbox-option' && !!inputValue) ||
    (inputName === 'attributes[greeting-card-message]' && !!inputValue) ||
    (inputName === 'attributes[greeting-card-free]' && inputValue?.checked)
  ) {
    setTimeout(() => {
      const accordion = document.querySelector(
        '.giftbox-selector-container > .accordion'
      );

      accordion && accordion.open();
    }, 300);
  }

  if(input.tagName === 'SELECT') {
    input.dispatchEvent(new Event('change'));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  [
    '[name^="attributes[fe-"]',
    '[name="attributes[greeting-card-free]"]',
    '[name="attributes[greeting-card-message]"]',
    '[name="giftbox-checkbox-option"]',
  ].forEach((selector) =>
    document.querySelectorAll(selector).forEach(inputWatcher)
  );

  document.querySelectorAll('[name="checkout"]')
  .forEach(checkoutButton => 
    checkoutButton.addEventListener('click', () => {
      [
        'attributes[fe-richiesta]',
        'attributes[fe-tipo-cliente]',
        'attributes[fe-azienda]',
        'attributes[fe-codice-fiscale]',
        'attributes[fe-piva]',
        'attributes[fe-sdi]',
        'attributes[fe-pec]',
        'attributes[fe-cig]',
        'attributes[fe-cup]',
        'attributes[fe-pagamenti-separati]',
        'attributes[greeting-card-free]',
        'attributes[greeting-card-message]',
        'gift-product-selector',
        'giftbox-checkbox-option',
      ].forEach((key) => {
        localStorage.removeItem(key)
      });
    })
  );

  const observer = new MutationObserver((mutationList) => {
    for (const mutation of mutationList) {
      const targetSelector = mutation.target.querySelector(
        '[name="gift-product-selector"]'
      );
      targetSelector && setTimeout(() => inputWatcher(targetSelector), 300);
      const targetButton = mutation.target.querySelector('button');
      targetButton &&
        targetButton.addEventListener('click', () => {
          localStorage.removeItem('gift-product-selector');
        });
    }
  });

  const productSelectorTarget = document.querySelector(
    '.product-selector-container'
  );
  const selectedProductTarget = document.querySelector(
    '.selected-products-container'
  );

  if (productSelectorTarget) {
    observer.observe(productSelectorTarget, {
      attributes: false,
      childList: true,
      subtree: false,
    });
  }

  if (selectedProductTarget) {
    observer.observe(selectedProductTarget, {
      attributes: false,
      childList: true,
      subtree: false,
    });
  }

  productSelectorTarget && observer.observe(
    productSelectorTarget, 
    {
      attributes: false,
      childList: true,
      subtree: false
    }
  );
});

// CART DISCOUNT COUPON LOGIC
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.discount-wrapper');
  const applyButton = document.getElementById('apply-discount');
  const removeButton = document.getElementById('remove-discount');
  const input = document.getElementById('discount-code');
  const messageEl = document.getElementById('discount-message');
  const banner = messageEl?.querySelector('.banner');
  let bannerTimeout;

  if (!applyButton || !removeButton || !input || !messageEl || !banner || !wrapper) return;

  const disableButtons = () => {
    applyButton.setAttribute('disabled', true);
    removeButton.setAttribute('disabled', true);
    applyButton.classList.add('disabled');
    removeButton.classList.add('disabled');
  };

  const enableButtons = () => {
    applyButton.removeAttribute('disabled');
    removeButton.removeAttribute('disabled');
    applyButton.classList.remove('disabled'); 
    removeButton.classList.remove('disabled');
  };

  const showBanner = (type, message) => {
    banner.classList.remove('banner--error', 'banner--success');
    if (type) banner.classList.add(type);
    banner.textContent = message;
    messageEl.removeAttribute('hidden');
    clearTimeout(bannerTimeout);
    bannerTimeout = setTimeout(() => {
      messageEl.setAttribute('hidden', true);
    }, 3000);
  };

  disableButtons();
  fetch('/cart.js')
    .then(res => res.json())
    .then(data => {
      if (data.discount_codes && data.discount_codes.length > 0 && data.discount_codes[0].applicable) {
        input.value = data.discount_codes[0].code;
        input.setAttribute('disabled', true);
        applyButton.setAttribute('hidden', true);
        removeButton.removeAttribute('hidden');
        showBanner('banner--success', window.discount_code.applied_successfully);
      } else {
        input.value = '';
        applyButton.removeAttribute('hidden');
        removeButton.setAttribute('hidden', true);
      }
    })
    .catch(() => {
      showBanner('banner--error', window.discount_code.error_loading);
    })
    .finally(() => {
      wrapper.removeAttribute('hidden');
      enableButtons();
    });

  applyButton.addEventListener('click', (e) => {
    e.preventDefault();
    const code = input.value.trim();

    if (!code) {
      showBanner('banner--error', window.discount_code.enter_discount_message);
      return;
    }

    disableButtons();

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: code })
    })
      .then(res => res.json())
      .then(data => {
        const discount = data.discount_codes?.[0];
        if (discount?.applicable) {
          window.location.reload();
        } else {
          showBanner('banner--error', window.discount_code.invalid_code);
        }
      })
      .catch(() => {
        showBanner('banner--error', window.discount_code.invalid_code);
      })
      .finally(() => {
        enableButtons();
      });
  });

  removeButton.addEventListener('click', (e) => {
    e.preventDefault();
    disableButtons();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: '' })
    })
      .then(res => res.json())
      .then(data => {
        if (data.discount_codes.length === 0) {
          window.location.reload();
        } else {
          showBanner('banner--error', window.discount_code.error_removing);
        }
      })
      .catch(() => {
        showBanner('banner--error', window.discount_code.error_removing);
      })
      .finally(() => {
        enableButtons();
      });
  });
});


// Handle fading text element for collapsible-text section

function handleFadingCollapsibleElements() {
  const fadingElements = document.querySelectorAll('.collapsible-fading-text-container');

  if (fadingElements.length == 0) return;
  Array.from(fadingElements).forEach(fadingElement => {
    const textContainer = fadingElement.querySelector('.text-container');
    const showMoreButton = fadingElement.querySelector('.show-more-button');
    const showLessButton = fadingElement.querySelector('.show-less-button');
    const fadeElement = fadingElement.querySelector('.fade-text');
    const title = fadingElement.querySelector('.title');

    if (!textContainer || !showMoreButton || !showLessButton || !fadeElement) return;

    
    const lineHeightPx = getComputedStyle(textContainer).getPropertyValue('line-height');
    const lineHeight = parseFloat(lineHeightPx.replace('px', ''));
    const isDesktop = window.innerWidth > 1007;
    const numberOfLines = isDesktop
      ? parseInt(getComputedStyle(textContainer).getPropertyValue('--visible-lines'))
      : parseInt(getComputedStyle(textContainer).getPropertyValue('--visible-lines-mobile'));
    const collapsedHeight = numberOfLines * lineHeight;
    const collapsedHeightPx = collapsedHeight + 'px';
    const fullHeight = textContainer.scrollHeight;
    const fullHeightPx = fullHeight + 'px';

    if (collapsedHeight > fullHeight / 2) {
      textContainer.style.height = fullHeightPx;
      showMoreButton.setAttribute('hidden', true);
      fadeElement.style.display = 'none';
      return;
    } else {
      showMoreButton.removeAttribute('hidden');
    }

    textContainer.style.height = collapsedHeightPx;

    function toggleContent(expand) {
      textContainer.style.height = expand ? fullHeightPx : collapsedHeightPx;
      showMoreButton.toggleAttribute('hidden', expand);
      showLessButton.toggleAttribute('hidden', !expand);
      fadeElement.style.opacity = expand ? '0' : '1';
    }

    showMoreButton.addEventListener('click', () => toggleContent(true));
    showLessButton.addEventListener('click', () => toggleContent(false));
    title?.addEventListener('click', () => toggleContent(showMoreButton.hasAttribute('hidden') ? false : true));
  });
}

document.addEventListener('DOMContentLoaded', handleFadingCollapsibleElements);